var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.732,
    height: 17.985,
    viewBox: "0 0 20.732 17.985",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Twitter",
    d: "M20.732,4.129a8.427,8.427,0,0,1-2.449.717,4.473,4.473,0,0,0,1.87-2.508,8.174,8.174,0,0,1-2.7,1.1,4.064,4.064,0,0,0-4.664-1.118,4.545,4.545,0,0,0-2.688,4.221,4.977,4.977,0,0,0,.1,1.035A11.793,11.793,0,0,1,1.443,2.827,4.734,4.734,0,0,0,2.75,8.892a4,4,0,0,1-1.92-.559v.05a4.5,4.5,0,0,0,3.405,4.459,3.989,3.989,0,0,1-1.114.149,3.527,3.527,0,0,1-.8-.077,4.336,4.336,0,0,0,3.971,3.161,8.2,8.2,0,0,1-5.27,1.935A7.462,7.462,0,0,1,0,17.949a11.419,11.419,0,0,0,6.52,2.036c7.821,0,12.1-6.917,12.1-12.913,0-.2-.006-.394-.016-.587A8.819,8.819,0,0,0,20.732,4.129Z",
    transform: "translate(0 -2)",
    fill: "#03a9f4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.83398f77bb34a3eb939708fffe3cf5aa.svg";
export { ForwardRef as ReactComponent };